export default __webpack_public_path__ + "static/media/Ntorq125_LateralIzq.b88dee7b.webp";